import { storeConstants } from '@utils/constants';
import {
    normalizeReportEventOrderDetails,
    normalizeReportEventOrderDetailsTotals,
} from '@utils/storeDataNormalization';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import { apiService } from '@api';

const STORE_NAME = 'eventOrderDetails';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.reports.eventOrderDetails.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
        mapListItemFn: normalizeReportEventOrderDetails,
    },
    {
        state: {
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            reportTotals: (state) => normalizeReportEventOrderDetailsTotals(state.totals),
        },
        mutations: {
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
        },
    }
);

export default store;
